import { complexSelectorActions } from '../../services';

export const complexSelectorDispatcher = dispatch => ( {
  setComplexSelector: data => dispatch( { type: complexSelectorActions.SET, data } ),
  resetComplexSelector: () => dispatch( { type: complexSelectorActions.RESET } )
} );
